import { useEffect, useState } from 'react';

/**
 * True at or above a viewport width — the JS half of a layout fork.
 *
 * The Lesson Dashboard mounts the warmup player ONCE: in the right column at
 * ≥1200px (where that column exists) and above the notes below it. CSS could
 * hide one of two copies, but two copies means two components with their own
 * "current exercise" fighting over one engine, so the choice has to be made in
 * JS. Same guard and the same default as Portal/Work/useIsMobile: no
 * matchMedia (jsdom, SSR) → DESKTOP, the pre-existing three-pane behaviour.
 */
const supported = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export default function useMinWidth(px) {
	const query = `(min-width: ${px}px)`;
	const [matches, setMatches] = useState(() => (supported() ? window.matchMedia(query).matches : true));
	useEffect(() => {
		if (!supported()) return undefined;
		const mql = window.matchMedia(query);
		const onChange = (e) => setMatches(e.matches);
		mql.addEventListener('change', onChange);
		setMatches(mql.matches);
		return () => mql.removeEventListener('change', onChange);
	}, [query]);
	return matches;
}
